import SocialMedia, { SocialType} from './SocialMedia';

export type { SocialType };
export default SocialMedia;
